const Profile = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={23}
    fill={!!props?.fill ? props.fill : "#000"}
    {...props}
  >
    <path
      fill={!!props?.fill ? props.fill : "#000"}
      d="M2.149 22.71H.229c0-1.42-.04-3-.02-4.25.01-.98.44-1.78 1.14-2.44.8-.76 1.75-1.29 2.76-1.71 1.47-.61 3-.98 4.57-1.18 3.44-.44 6.85-.27 10.17.81 1.14.37 2.23.87 3.2 1.6 1.15.88 1.62 1.72 1.74 3.42.04 1.12-.03 2.64-.04 3.82-.65.02-.97.02-1.92.03V21.8c.01-1.15.01-1.67 0-2.45.04-.72-.25-1.26-.74-1.73-.84-.81-1.86-1.32-2.95-1.7-2.83-.99-5.74-1.23-8.7-.83-1.23.17-2.45.49-3.65.85-.72.22-1.4.6-2.05.99-1.09.66-1.64 1.2-1.57 2.95 0 .92 0 1.66-.02 2.81v.02ZM12.028 0c3.18.03 5.66 2.58 5.6 5.78a5.662 5.662 0 0 1-5.69 5.54c-3.08-.02-5.59-2.55-5.61-5.63a5.633 5.633 0 0 1 5.71-5.68l-.01-.01Zm-3.65 5.63c0 2.01 1.59 3.64 3.58 3.65 1.95.01 3.63-1.65 3.65-3.61.01-1.98-1.62-3.62-3.61-3.63-2.02 0-3.61 1.57-3.62 3.59Z"
    />
  </svg>
);
export default Profile;
